import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/Login",
  },
  {
    path: "/Login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    redirect: "/OrderList",
    children: [
      // 数据统计
      { path: "/Visualization", name: "Visualization", component: () => import("../views/Visualization.vue") },
      // 运单管理
      { path: "/OrderList", name: "OrderList", component: () => import("../views/Order.vue") },
       { path: "/UpdateOrder", name: "UpdateOrder", component: () => import("../views/UpdateOrder.vue") },
      { path: "/PackageList", name: "PackageList", component: () => import("../views/PackageList.vue") },
      { path: "/ShelfManager", name: "ShelfManager", component: () => import("../views/ShelfManager.vue") },
      { path: "/CouponManager", name: "CouponManager", component: () => import("../views/CouponManager.vue") },
      { path: "/FriendAssistCoupon", name: "FriendAssistCoupon", component: () => import("../views/FriendAssistCoupon.vue") },
      { path: "/ReviewManager", name: "ReviewManager", component: () => import("../views/ReviewManager.vue") },
      { path: "/GroupRouteManager", name: "GroupRouteManager", component: () => import("../views/GroupRouteManager.vue") },
      { path: "/GroupLeaderApply", name: "GroupLeaderApply", component: () => import("../views/GroupLeaderApply.vue") },
      // 商城管理
      { path: "/shopOrderList", name: "shopOrderList", component: () => import("../views/shopOrder.vue") },
      { path: "/goodsManager", name: "goodsManager", component: () => import("../views/goodsManager.vue") },
      // 财务管理管理
      { path: "/PaymentConfirm", name: "PaymentConfirm", component: () => import("../views/PaymentConfirm.vue") },
      { path: "/RoutePlan", name: "RoutePlan", component: () => import("../views/RoutePlan.vue") },
      // 用户管理
      { path: "/UserList", name: "UserList", component: () => import("../views/UserList.vue") },
      { path: "/AgentList", name: "AgentList", component: () => import("../views/AgentList.vue") },
      { path: "/AgentLog", name: "AgentLog", component: () => import("../views/AgentLog.vue") },
      { path: "/Admin", name: "Admin", component: () => import("../views/Admin.vue"), meta: { role: "超级管理员" } },
      // 运营专区
      { path: "/AiOperation", name: "AiOperation", component: () => import("../views/AiOperation.vue") },
      // 内容设置
      { path: "/UIAndProtocol", name: "UIAndProtocol", component: () => import("../views/Setting.vue") },
      { path: "/News", name: "News", component: () => import("../views/News.vue") },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
